import { render, staticRenderFns } from "./CodemasterButtons.vue?vue&type=template&id=06764477&"
import script from "./CodemasterButtons.vue?vue&type=script&lang=js&"
export * from "./CodemasterButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports